var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrakes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02301 8.77905C5.02301 10.4361 6.36601 11.7791 8.02201 11.7791C9.67901 11.7791 11.023 10.4361 11.023 8.77905C11.023 7.12205 9.67901 5.77905 8.02201 5.77905C6.36601 5.77905 5.02301 7.12205 5.02301 8.77905Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27901 7.912L1.08301 6.613L1.29901 5.927C1.91301 5.15 3.37701 5.432 3.52701 6.344L4.81301 6.595C4.72301 6.719 4.63801 6.848 4.56501 6.985C4.41601 7.287 4.32201 7.599 4.27901 7.912Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.103 6.67806L12.428 6.36806C12.537 5.47106 14.005 5.12706 14.641 5.90706L14.87 6.58006L11.597 8.04406C11.566 7.75506 11.496 7.46806 11.379 7.19106C11.303 7.01006 11.209 6.84006 11.103 6.67806Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakes);
export default __webpack_public_path__ + "static/media/brakes.b82abb28.svg";
export { ForwardRef as ReactComponent };